

export function generateFabricItemId() {
 const timePart = Date.now().toString().slice(-5); 
 const randomPart = Math.floor(1000 + Math.random() * 9000); 
 return Number(timePart + randomPart); // 9 رقمی
}
